// Message
export const MESSAGE_ERROR = 'MESSAGE_ERROR'
export const MESSAGE_SUCCESS = 'MESSAGE_SUCCESS'

// Auth and User
export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_VIP_REQUEST = 'USER_VIP_REQUEST'
export const USER_VXU_REQUEST = 'USER_VXU_REQUEST'
export const USER_OPEN_REQUEST = 'USER_OPEN_REQUEST'
export const USER_VXU_OPEN_REQUEST = 'USER_VXU_OPEN_REQUEST'
// Slides
export const SLIDE_REQUEST = 'SLIDE_REQUEST'
// Games
export const GAME_REQUEST = 'GAME_REQUEST'
export const GAME_BY_ID = 'GAME_BY_ID'
export const GAME_NAME = 'GAME_NAME'
// Server
export const SERVER_REQUEST = 'SERVER_REQUEST'
export const CHARACTER_REQUEST = 'CHARACTER_REQUEST'
export const SERVER_GROUP_REQUEST = 'SERVER_GROUP_REQUEST'
export const SERVER_GROUP_NAME_REQUEST = 'SERVER_GROUP_NAME_REQUEST'
// Giftcode
export const GIFTCODE_REQUEST = 'GIFTCODE_REQUEST'
export const GIFTCODE_GENERIC_REQUEST = 'GIFTCODE_GENERIC_REQUEST'
export const GIFTCODE_UNIQUE_REQUEST = 'GIFTCODE_UNIQUE_REQUEST'
export const GIFTCODE_VIP_REQUEST = 'GIFTCODE_VIP_REQUEST'
export const GIFTCODE_OPEN_REQUEST = 'GIFTCODE_OPEN_REQUEST'
export const GIFTCODE_SEND = 'GIFTCODE_SEND'
export const GIFTCODE_ADD = 'GIFTCODE_ADD'
export const GIFTCODE_HISTORY = 'GIFTCODE_HISTORY'
export const GIFTCODE_DETAIL = 'GIFTCODE_DETAIL'
export const GIFTCODE_SHOW = 'GIFTCODE_SHOW'
